import type { ContactMessageStatus } from './entity_types/ContactMessage';
import { hFetch } from './hFetch';

type ListContactMessageDto = {
  status: ContactMessageStatus;
  body: string;
  created_at: string;
  name: string;
  id: number;
};

type ListContactMessagesArgs = {
  pageQuery: string;
  keywordQuery: string;
};
type ListContactMessagesResponse = {
  records: ListContactMessageDto[];
  total: number;
  start_entry: number;
  end_entry: number;
};
export const listContactMessages = async ({
  pageQuery,
  keywordQuery,
}: ListContactMessagesArgs): Promise<ListContactMessagesResponse | undefined> => {
  return await hFetch({ url: `/api/contact_messages?${pageQuery}&${keywordQuery}` });
};

export const markBulkContactMessagesAsRead = (contactIds: number[]) => {
  return hFetch({
    url: '/api/contact_messages/bulk_mark_as_read',
    method: 'POST',
    payload: { ids: contactIds },
  }) as Promise<{ message: 'success' }>;
};
